import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";


/* =========================
   ROLE LIST
========================= */

export const RoleList = (props) => {
  const { permissions = [] } = usePermissions();
  console.log("Permissions in RoleList:", permissions);

  return (
    <List title="Roles" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Roles
        </Typography>
      </Box>
      <Datagrid
        bulkActionButtons={
          permissions.includes("roles.delete") || permissions.includes("roles.*") || permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />

        {(permissions.includes("roles.edit") || permissions.includes("roles.*") || permissions.includes("*")) && (
          <EditButton />
        )}
       
      </Datagrid>
    </List>
  );
};